// extracted by mini-css-extract-plugin
export default {"hiddenButton":"styles_hiddenButton__u0yOe"};